//@flow
import React from "react"
import { connect } from "react-redux"
import { replace, push } from "react-router-redux"
import { compose } from "react-apollo"
import { Helmet } from "react-helmet"
import moment from "moment"
import {
  EntityHeading,
  EntityDetail,
  Entity,
  EntityAction,
  EntityPrimaryLink
} from "../UI/EntityList"
import { parseQueryString } from "../RoutingHelpers"
import { SearchTableView } from "../SearchTableView"
import queries from "./queries"
import type { KioskListViewProps } from "./types"
import { confirmDeletePath } from "./helpers"

type State = { mutationLoading: boolean }

class KioskListView extends React.Component<KioskListViewProps, State> {
  constructor(props) {
    super(props)
    this.state = { mutationLoading: false }
  }

  async handleDelete(id: string) {
    const { kiosks: { refetch }, deleteKiosk } = this.props
    this.setState(() => ({
      mutationLoading: true
    }))
    await deleteKiosk(id)
    await refetch()
    this.setState(() => ({
      mutationLoading: false
    }))
  }

  render() {
    const {
      kiosks: { kiosks, loading },
      match,
      replace,
      searchName,
      history: { push }
    } = this.props
    const kioskCount = kiosks ? kiosks.length : 0
    return (
      <SearchTableView
        url={match.url}
        routerAction={replace}
        entityName="Kiosks"
        searchName={searchName}
        handleNewClick={() => push(`${match.url}/new`)}
        loading={loading || this.state.mutationLoading}
      >
        <Helmet>
          <title>
            {`${kioskCount} Kiosk${kioskCount === 1 ? "" : "s"}${searchName !==
            ""
              ? ` Matching '${searchName}'`
              : ""}`}
          </title>
        </Helmet>
        <EntityHeading>
          <EntityDetail grow={2}>Name</EntityDetail>
          <EntityDetail grow={1}>Starts</EntityDetail>
          <EntityDetail grow={1}>Expires</EntityDetail>
          <EntityDetail grow={1} shrink={0} />
        </EntityHeading>
        {kiosks &&
          kiosks.map(kiosk => (
            <Entity key={kiosk.id}>
              <EntityDetail grow={2}>
                <EntityPrimaryLink to={`${match.url}/${kiosk.id || "new"}`}>
                  {kiosk.friendlyName || kiosk.id}
                </EntityPrimaryLink>
              </EntityDetail>
              <EntityDetail grow={1}>
                {moment(kiosk.startsAt).format("M-D-YYYY")}
              </EntityDetail>
              <EntityDetail grow={1}>
                {moment(kiosk.endsAt).format("M-D-YYYY")}
              </EntityDetail>
              <EntityDetail grow={1} shrink={0} row end>
                <EntityAction
                  href="#"
                  onClick={() => push(`${match.url}/${kiosk.id || "new"}`)}
                  icon="✏️"
                />
                <EntityAction
                  href="#"
                  onClick={() => push(confirmDeletePath(kiosk.id || ""))}
                  icon="❌"
                />
              </EntityDetail>
            </Entity>
          ))}
      </SearchTableView>
    )
  }
}

const KiosksWithData = compose(queries.withKiosks)(KioskListView)

export default connect(
  state => ({
    searchName: parseQueryString(state, "name")
  }),
  {
    replace,
    push
  }
)(KiosksWithData)



// WEBPACK FOOTER //
// ./src/Kiosks/KioskListView.js